import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail } from 'lucide-react';

const Footer9 = () => {
    const navigate = useNavigate();

    const quickLinks = [
        { label: 'Home', path: '/template9' },
        { label: 'Shop', path: '/template9/shop' },
        { label: 'About Us', path: '/template9/about' },
        { label: 'Contact', path: '/template9/contact' },
    ];

    const customerLinks = [
        { label: 'My Orders', path: '/template9/orders' },
        { label: 'My Profile', path: '/template9/profile' },
        { label: 'FAQs', path: '/template9/faqs' },
        { label: 'Shipping & Exchange', path: '/template9/shipping' },
    ];

    const legalLinks = [
        { label: 'Terms & Conditions', path: '/template9/terms' },
        { label: 'Privacy Policy', path: '/template9/privacy' },
    ];

    return (
        <footer className="bg-white border-t border-[#E2E8F0]" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            {/* Blue accent line at top */}
            <div className="w-full h-0.5 bg-[#2563EB]" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {/* Brand Column */}
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-2 h-6 bg-[#2563EB] rounded-none" />
                            <span className="text-xl font-bold tracking-[3px] text-[#0F172A]">NAKSHA</span>
                        </div>
                        <p className="text-sm text-[#64748B] leading-relaxed mb-6 font-light">
                            Precision-crafted Indian fashion bridging heritage artistry with contemporary design.
                        </p>
                        <div className="flex gap-4">
                            <a href="#" className="text-[#64748B] hover:text-[#2563EB] transition-colors duration-300">
                                <Instagram size={18} />
                            </a>
                            <a href="#" className="text-[#64748B] hover:text-[#2563EB] transition-colors duration-300">
                                <Facebook size={18} />
                            </a>
                            <a href="#" className="text-[#64748B] hover:text-[#2563EB] transition-colors duration-300">
                                <Twitter size={18} />
                            </a>
                            <a href="#" className="text-[#64748B] hover:text-[#2563EB] transition-colors duration-300">
                                <Mail size={18} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-sm font-semibold text-[#0F172A] uppercase tracking-wider mb-4">
                            Quick Links
                        </h4>
                        <div className="w-6 h-0.5 bg-[#2563EB] mb-4" />
                        <ul className="space-y-3">
                            {quickLinks.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-[#64748B] hover:text-[#2563EB] transition-colors duration-300 bg-transparent border-none cursor-pointer p-0 font-light"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Customer Service */}
                    <div>
                        <h4 className="text-sm font-semibold text-[#0F172A] uppercase tracking-wider mb-4">
                            Customer Service
                        </h4>
                        <div className="w-6 h-0.5 bg-[#2563EB] mb-4" />
                        <ul className="space-y-3">
                            {customerLinks.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-[#64748B] hover:text-[#2563EB] transition-colors duration-300 bg-transparent border-none cursor-pointer p-0 font-light"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Legal */}
                    <div>
                        <h4 className="text-sm font-semibold text-[#0F172A] uppercase tracking-wider mb-4">
                            Legal
                        </h4>
                        <div className="w-6 h-0.5 bg-[#2563EB] mb-4" />
                        <ul className="space-y-3">
                            {legalLinks.map((link) => (
                                <li key={link.label}>
                                    <button
                                        onClick={() => navigate(link.path)}
                                        className="text-sm text-[#64748B] hover:text-[#2563EB] transition-colors duration-300 bg-transparent border-none cursor-pointer p-0 font-light"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-6">
                            <p className="text-sm text-[#64748B] font-light">
                                <Mail size={14} className="inline mr-2" />
                                hello@naksha.in
                            </p>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-[#64748B] font-light">
                        &copy; 2026 NAKSHA. All rights reserved.
                    </p>
                    <p className="text-xs text-[#64748B] font-light">
                        Designed with precision. Crafted with heritage.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer9;
